module.exports = __webpack_public_path__ + "static/media/img-04.020e74e3.jpg";